import { useLanguage } from "../../contexts/LanguageContext";
import { getTranslation } from "../../translations";
import useFadeIn from "../../hooks/useFadeIn";
import "../../hooks/useFadeIn.css";
import "./CompanySection.css";

function CompanySection() {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const contentFade = useFadeIn();
  const headerFade = useFadeIn();
  const descFade = useFadeIn({ delay: 200 });
  const feat1Fade = useFadeIn({ delay: 300 });
  const feat2Fade = useFadeIn({ delay: 400 });
  const feat3Fade = useFadeIn({ delay: 500 });


  return (
    <section className="company-section">
      <div className="company-top">
        <div
          ref={headerFade.ref}
          className={`company-header fade-in-element ${headerFade.isVisible ? 'visible' : ''}`}
        >
          <span className="company-label">{t('company.label')}</span>
          <h2 className="company-title">{t('company.title')}</h2>

        </div>

        <div className="company-features">
          <div
            ref={feat1Fade.ref}
            className={`feature-item fade-in-element ${feat1Fade.isVisible ? 'visible' : ''}`}
          >
            <div className="feature-text">
              <span className="feature-light">{t('company.feature1Light')}</span>
              <span className="feature-bold">{t('company.feature1Bold')}</span>
            </div>
            <img src="/icons/1.svg" alt="" className="feature-icon" />
          </div>

          <div
            ref={feat2Fade.ref}
            className={`feature-item fade-in-element ${feat2Fade.isVisible ? 'visible' : ''}`}
          >
            <div className="feature-text">
              <span className="feature-light">{t('company.feature2Light')}</span>
              <span className="feature-bold">{t('company.feature2Bold')}</span>
            </div>
            <img src="/icons/2.svg" alt="" className="feature-icon" />
          </div>

          <div
            ref={feat3Fade.ref}
            className={`feature-item fade-in-element ${feat3Fade.isVisible ? 'visible' : ''}`}
          >
            <div className="feature-text">
              <span className="feature-light">{t('company.feature3Light')}</span>
              <span className="feature-bold">{t('company.feature3Bold')}</span>
            </div>
            <img src="/icons/3.svg" alt="" className="feature-icon" />
          </div>
        </div>

        <div className="company-video-container">
          <video className="company-video" autoPlay loop muted playsInline>
            <source src="/videos/vision_2-1.mp4" type="video/mp4" />
          </video>
        </div>
      </div>

      <div className="company-content">


        <p
          ref={descFade.ref}
          className={`company-description fade-in-element ${descFade.isVisible ? 'visible' : ''}`}
        >
          {t('company.description')}
        </p>




      </div>
    </section>
  );
}

export default CompanySection;
